export const getAdobeAccountEventTracking = () => {
  if (typeof window === 'undefined' || typeof (window as any).adbAccEvent !== 'object') {
    return { track: () => {} };
  }
  return (window as any).adbAccEvent;
};
